export const phonesLines = {
  weekdays: 'Mon - Fri, 9am to 5pm',
  weekends: 'Sat, 9am to 1pm',
}

export const liveChat = {
  weekdays: 'Mon - Fri, 8:30am to 8pm',
  weekends: 'Sat - Sun, 9am to 5pm',
}
